import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { proposalMutationScopeId } from '@/api/mutations/proposals/proposalMutationScope';
import proposalKeys from '@/api/queries/proposal/keyFactor';
import { graphql } from '@/gql';
import {
  SetProposalGroupChildSelectedInput,
  SetProposalGroupChildSelectedMutation,
} from '@/gql/graphql';

const SET_PROPOSAL_GROUP_CHILD_SELECTED_MUTATION = graphql(`
  mutation SetProposalGroupChildSelected(
    $input: SetProposalGroupChildSelectedInput!
  ) {
    setProposalGroupChildSelected(input: $input) {
      id
    }
  }
`);

const useSetProposalGroupChildSelected = (args?: {
  proposalId?: string;
  options?: UseMutationOptions<
    SetProposalGroupChildSelectedMutation,
    unknown,
    SetProposalGroupChildSelectedInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};

  return useMutation({
    mutationFn: (input: SetProposalGroupChildSelectedInput) => {
      return gqlClient.request(SET_PROPOSAL_GROUP_CHILD_SELECTED_MUTATION, {
        input,
      });
    },
    scope: args?.proposalId
      ? { id: proposalMutationScopeId(args.proposalId) }
      : undefined,
    onSuccess: (data, variables, context) => {
      if (args?.proposalId) {
        void queryClient.invalidateQueries({
          queryKey: proposalKeys.proposal(args.proposalId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useSetProposalGroupChildSelected;
